import React, { useCallback, useState } from 'react';
import {Formik, FormikHelpers} from 'formik';
import './styles.css';
import { Values, cpfMask, dateMask, rgMask, MascaraRG, initialValues, validationSchema, cepMask, phoneMask } from './data';
import { contactService } from '../../services/contact';
import { AxiosError } from 'axios';
import { InputField } from '../../components/InputField';
import { SelectField } from '../../components/SelectField';
import { FileField } from '../../components/FileField';
import { isValid, parseISO, toDate, parse } from 'date-fns';
import * as cpfValidator from 'cpf-cnpj-validator';
import { api } from '../../services/api';

export const FichaCadastral = () => {

  const [sent, setSent] = useState(false);

  const [docResidencia, setDocResidencia] = useState<File | null>(null);
  const [docCertidao, setDocCertidao] = useState<File | null>(null);
  

  const handleSubmit = useCallback(async (values: any, formilHelpers: FormikHelpers<any>) => {
    // alert(JSON.stringify(values))

    // const cpfIsValid = cpfValidator.cpf.isValid(values.cpf);

    // if (!cpfIsValid) {
    //   formilHelpers.setFieldError('cpf', 'CPF inválido!')
    //   return;
    // }

    const nascimento = parse(values.nascimento, 'dd/MM/yyyy', new Date());
    const dataExp = parse(values.data_exp, 'dd/MM/yyyy', new Date());
    
    
    
    if (!isValid(nascimento)) {
      alert('A data de nascimento está inválida!')
      return;
    }

    if (!isValid(dataExp)) {
      alert('A data de expedição está inválida!')
      return;
    }

    if (values.conjuge_nome.length < 0) {
      const conjugeNascimento = parse(values.conjuge_nascimento, 'dd/MM/yyyy', new Date());
      const conjugeDataExp = parse(values.conjuge_data_exp, 'dd/MM/yyyy', new Date());
      if (!isValid(conjugeNascimento)) {
        alert('A data de nascimento do conjuge está inválida!')
        return;
      }

      if (!isValid(conjugeDataExp)) {
        alert('A data de expedição do documento do conjuge está inválida!')
        return;
    }
    }

    

    const dependenteNascimentoInvalido = values.dependentes.filter((d: any) => {

      const nascimento = parse(d.nascimento, 'dd/MM/yyyy', new Date());
      return !isValid(nascimento)
    }).length > 0; 

    if (dependenteNascimentoInvalido) {
      alert('A data de nascimento de um dos dependentes está inválida!')
      return;
    }

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    const ref = urlParams.get('ref') || '';

    const data = {
      ...values,
      ref
    }

    try {
      const res = await api.post('/ficha-cadastral', data);

      setSent(true);

      formilHelpers.resetForm();

      window.location.href = '/ficha-cadastral-obrigado';
    } catch (error) {
      if(error instanceof AxiosError) {
        formilHelpers.setFieldError('_error', error.response?.data?.message || 'Houve um error desconhecido. Tente novamente mais tarde!');
        return;
      }

      formilHelpers.setFieldError('_error', 'Houve um error desconhecido. Tente novamente mais tarde!')
    }


    return;
    // await new Promise((resolve) => setTimeout(resolve, 2000));

    try {
      const queryString = window.location.search;

      const urlParams = new URLSearchParams(queryString);

      const companyReferral = urlParams.get('your-company-referral') || '';
      const userReferred = urlParams.get('your-user-referred') || '';
      const gclid = urlParams.get('gclid') || '';
      const fbclid = urlParams.get('fbclid') || '';
      const wbraid = urlParams.get('wbraid') || '';
      const url = window.location.href || '';
      const utmSource = urlParams.get('utm_source') || '';
      const utmMedium = urlParams.get('utm_medium') || '';

      await contactService.send({
        ...values,
        companyReferral,
        userReferred,
        gclid,
        fbclid,
        url,
        utmSource,
        utmMedium,
        wbraid,
      });

      setSent(true);

      window.location.href = '/obrigado';

    } catch (error: any) {

      if(error instanceof AxiosError) {
        formilHelpers.setFieldError('_error', error.response?.data?.message || 'Houve um error desconhecido. Tente novamente mais tarde!');
        return;
      }

      formilHelpers.setFieldError('_error', 'Houve um error desconhecido. Tente novamente mais tarde!')
    }


  }, []);

  return <div className="form-container">
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue}) => (
        <form action="input-name" onSubmit={handleSubmit}>

          {/* {JSON.stringify(errors)} */}

          <h2>Dados Pessoais</h2>

          <div className='form-row'>
            <InputField
              label='Nome completo'
              name="nome"
              required
            />
          </div>

          <div className='form-row'>
            <InputField
              label='CPF'
              name="cpf"
              required
              mask={cpfMask}
            />

            <InputField
              label='Data de nascimento'
              name="nascimento"
              required
              mask={dateMask}
            />
          </div>

          <div className='form-row'>
            <InputField
              label='Identidade'
              name="rg"
              required
              mask={rgMask}
            />

            <InputField
              label='Orgão exp'
              required
              name="org_exp"
            />

            <InputField
              label='Data exped'
              name="data_exp"
              required
              mask={dateMask}
            />
          </div>

          <div className='form-row'>
            <InputField
              label='Nacionalidade'
              name="nacionalidade"
              required
            />
          </div>

          

          
         
          <div className='form-row'>

            <InputField
              label='CEP'
              name="cep"
              required
              mask={cepMask}
            />

            <InputField
              label='Cidade'
              name="cidade"
              required
            />

            <InputField
              label='Bairro'
              name="bairro"
              required
            />

            
          </div>

          <div className='form-row'>
            <InputField
              label='Endereço'
              name="endereco"
              required
            />
          </div>

          <div className='form-row'>
            <InputField
              type='email'
              label='E-mail'
              name="email"
              required
            />

            <InputField
              // type='tel'
              label='Celular / WhatsApp'
              name="celular"
              required
              mask={phoneMask}
            />
          </div>

          <div className='form-row'>
            <FileField
              type='file'
              label='Comprovante de residência'
              name="comprovante_residencia"
              required
              accept=".pdf,.jpg,.jpeg,.png"
            />
          </div>

          <div className='form-row'>
            {/* <InputField
              label='Estado Civil'
              name="estado_civil"
              required
            /> */}

            <SelectField
              label='Estado Civil'
              name="estado_civil"
              style={{maxWidth: '200px'}}
            />
          </div>
          
          

          {values.estado_civil === 'Casado(a)' && (
            <div>
              <h2>Dados do Cônjuge</h2>

              <div className='form-row'>
                <InputField
                  label='Nome'
                  name="conjuge_nome"
                  // required
                />
              </div>

              <div className='form-row'>
                <InputField
                  label='CPF'
                  name="conjuge_cpf"
                  required={values.conjuge_nome.length > 0}
                  mask={cpfMask}
                />

                <InputField
                  label='Data de nascimento'
                  name="conjuge_nascimento"
                  required={values.conjuge_nome.length > 0}
                  mask={dateMask}
                />
              </div>

              <div className='form-row'>
                <InputField
                  label='Identidade'
                  name="conjuge_rg"
                  required={values.conjuge_nome.length > 0}
                  mask={rgMask}
                />

                <InputField
                  label='Orgão exp'
                  name="conjuge_org_exp"
                  required={values.conjuge_nome.length > 0}
                />

                <InputField
                  label='Data exped'
                  name="conjuge_data_exp"
                  required={values.conjuge_nome.length > 0}
                  mask={dateMask}
                />
              </div>

              <div className='form-row'>
                <InputField
                  type='email'
                  label='E-mail'
                  name="conjuge_email"
                  required={values.conjuge_nome.length > 0}
                />

                <InputField
                  type='tel'
                  label='Celular / WhatsApp'
                  name="conjuge_celular"
                  mask={phoneMask}
                  required={values.conjuge_nome.length > 0}
                />
              </div>

              <div className='form-row'>
                <FileField
                  type='file'
                  label='Certidão de casamento ou união estável'
                  name="conjuge_comprovante"
                  required={values.conjuge_nome.length > 0}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </div>
            </div>
          )}

          <h2>Dados dos parentes aptos a serem dependentes (filhos, pai, mãe e sogra)</h2>

          {values.dependentes.map((_, idx) => (

            <div key={idx} className='form-group'>
              <h3>Dependente {idx + 1}</h3>
              
              <div className='form-row'>
                <InputField
                  label='Nome Completo'
                  name={`dependentes[${idx}][nome]`}
                  value={values.dependentes[idx].nome}
                  parentName="dependentes"
                  childName="nome"
                  idx={idx}
                  required
                />
              </div>

              <div className='form-row'>
                <InputField
                  label='CPF'
                  name={`dependentes[${idx}][cpf]`}
                  value={values.dependentes[idx].cpf}
                  parentName="dependentes"
                  childName="cpf"
                  idx={idx}
                  required
                  mask={cpfMask}
                />

                <InputField
                  label='Data de nascimento'
                  name={`dependentes[${idx}][nascimento]`}
                  value={values.dependentes[idx].nascimento}
                  parentName="dependentes"
                  childName="nascimento"
                  idx={idx}
                  mask={dateMask}
                />
              </div>

              <div className='form-row'>
                <FileField
                  type='file'
                  label='Certidão de nascimento'
                  name={`dependentes[${idx}][certidao_nascimento]`}
                  parentName="dependentes"
                  childName="certidao_nascimento"
                  idx={idx}
                  required
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </div>
              
          </div>

          ))}

          <div className='form-field'>
            <button type="button" onClick={() => {
              setFieldValue('dependentes', [...values.dependentes, {nome: '', cpf: '', nascimento: '', certidao_nascimento: ''}])
            }}>Adicionar dependente</button>

            {values.dependentes.length > 0 && (
              <button type="button" style={{marginLeft: 20}} onClick={() => {
                setFieldValue('dependentes', [...values.dependentes.slice(0, -1)])
              }}>Remover dependente</button>
            )}
          </div>

          
          

          <div className='form-field'>

            {errors._error && touched._error ? (
             <div className="form-error mb">{errors._error}</div>
            ) : null}

            <input 
              type="submit" 
              className="input-submit" 
              value={isSubmitting ? 'Aguarde...' : 'Enviar'} 
              disabled={isSubmitting || sent}
            />
          </div>
        </form>
      )}
    </Formik>
    
  </div>;
}